import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

const devConfig = {
    apiKey: "AIzaSyDHnL-Gz5rlscK21tRxuPgIysZr340O48g",
    authDomain: "paul-staging.firebaseapp.com",
    databaseURL: "https://paul-staging.firebaseio.com",
    projectId: "paul-staging",
    storageBucket: "paul-staging.appspot.com",
    messagingSenderId: "246757054652"
};

const prodConfig = {
  apiKey: "AIzaSyCG6UcudlgQp0t7ntmvQuPP3kQ4meJwS44",
  authDomain: "paul-production.firebaseapp.com",
  databaseURL: "https://paul-production.firebaseio.com",
  projectId: "paul-production",
  storageBucket: "paul-production.appspot.com",
  messagingSenderId: "1040881423362"
};

const config = process.env.REACT_APP_ENV === 'production'
  ? prodConfig
  : devConfig;

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

const db = firebase.database();
const auth = firebase.auth();

export {
  db,
  auth,
};



// WEBPACK FOOTER //
// ./src/firebase/firebase.js